import { useState } from 'react';
import axios from 'axios';
import { setTokens } from '../../services/auth';
export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);
  const entrar = async (e) => {
    e.preventDefault();
    if (!username || !password) { setErro('Preencha usuario e senha.'); return; }
    setLoading(true); setErro('');
    try {
      const res = await axios.post((process.env.REACT_APP_API_URL || 'https://erp.zephirvarais.com.br/api') + '/auth/token/', { username, password });
      setTokens(res.data.access, res.data.refresh);
      window.location.href = '/';
    } catch { setErro('Usuario ou senha incorretos.'); }
    finally { setLoading(false); }
  };
  return (
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'var(--z-navy)'}}>
      <div style={{background:'#fff',borderRadius:12,padding:'40px 48px',width:'100%',maxWidth:400,boxShadow:'0 8px 40px rgba(0,0,0,0.25)'}}>
        <div style={{textAlign:'center',marginBottom:32}}>
          <img src="/logo.png" alt="Zephir" style={{width:160,marginBottom:8,mixBlendMode:'multiply'}}/>
          <div style={{fontSize:13,color:'var(--z-text-muted)'}}>Sistema de Gestao</div>
        </div>
        <form onSubmit={entrar}>
          <div className="form-group" style={{marginBottom:16}}>
            <label className="form-label">Usuario</label>
            <input className="form-input" value={username} onChange={e=>setUsername(e.target.value)} placeholder="seu.usuario" autoFocus/>
          </div>
          <div className="form-group" style={{marginBottom:24}}>
            <label className="form-label">Senha</label>
            <input className="form-input" type="password" value={password} onChange={e=>setPassword(e.target.value)} placeholder="â€¢â€¢â€¢â€¢â€¢â€¢â€¢â€¢"/>
          </div>
          {erro&&<div style={{background:'#fee2e2',color:'#dc2626',borderRadius:6,padding:'8px 12px',fontSize:13,marginBottom:16}}>{erro}</div>}
          <button type="submit" className="btn btn-primary" style={{width:'100%',justifyContent:'center',padding:'10px',fontSize:14}} disabled={loading}>
            {loading?'Entrando...':'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}


